/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InsurerDto } from '../../models/insurer-dto';

export interface InsurerGet$Params {
  InsurerId?: string;
  IsActive?: boolean;
  IsTest?: boolean;
  IsVisibleForHospitals?: boolean;
}

export function insurerGet(http: HttpClient, rootUrl: string, params?: InsurerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InsurerDto>>> {
  const rb = new RequestBuilder(rootUrl, insurerGet.PATH, 'get');
  if (params) {
    rb.query('InsurerId', params.InsurerId, {});
    rb.query('IsActive', params.IsActive, {});
    rb.query('IsTest', params.IsTest, {});
    rb.query('IsVisibleForHospitals', params.IsVisibleForHospitals, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InsurerDto>>;
    })
  );
}

insurerGet.PATH = '/v1/Insurer/Get';
